import React from "react";
import TripSchedule from "../../../components/ScheduleService/TripSchedule/TripSchedule";

type Props = {
  params: { careTakerId: string; serviceUserId: string };
  date: string | null;
};

const TripScheduleContainer: React.FC<Props> = ({ params, date }) => {
  return <TripSchedule params={params} date={date} />;
};

export default TripScheduleContainer;
